import { Backdrop, Grid } from '@mui/material';
import CircularLoader from './CircularLoader';
import { Box } from '@mui/system';
import { useSelector } from 'store';

const BackDropLoader = () => {
    const backdrop = useSelector((state) => state.backdrop);

    return (
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={backdrop?.open || false}>
            <Grid container>
                <Grid item xs={12}>
                    <CircularLoader size={24} />
                </Grid>
                {backdrop?.message !== '' && (
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="center">
                            {backdrop?.message}
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Backdrop>
    );
};

export default BackDropLoader;
